import assert from 'assert'

async function sendMessage3(pid, title_part, action, content, receiver = 'ALL') {
  assert(!!pid)
  console.log('sendMessage3', arguments)
  const project = await app.service('project').fetch(pid)
  if (!project) {
    throw new Error('project is null！')
  }
  assert(['ALL', '客户经理', '项目成员'].indexOf(receiver) >= 0)

  let toAccounts
  if (receiver === 'ALL') {
    toAccounts = getAllReceiver(project)
  } else if (receiver === '客户开发') {
    toAccounts = project.客户开发
  } else {
    toAccounts = project.项目成员
  }
  if (!Array.isArray(toAccounts) || toAccounts.length === 0) {
    console.log('do not have receiver')
    return
  }

  const pName = project.项目名称
  const type = '项目'
  const title = pName + title_part
  let data = { type, action, title, content, pid, pName }
  checkFields(data, ['type', 'action', 'title', 'content', 'pid'])
  data = { notify: data, to: toAccounts }
  const ans = await app.service('notify').addNotify(data)
  console.log('notify data:', data, ans.status)
}

async function sendMessage(rid, pid, title_part, action, content, def_toAccounts) {
  assert(!!rid)
  assert(!!pid)
  const project = await app.service('project').fetch(pid)
  let radish = await app.service('radish').simpleFetch({ _id: rid })
  if (!project || !radish.data) {
    throw new Error('project or radish is null！')
  }
  radish = radish.data

  let toAccounts
  if (Array.isArray(def_toAccounts)) {
    toAccounts = def_toAccounts
  } else {
    toAccounts = getAllReceiver(project)
  }
  const rName = radish.姓名
  const pName = project.项目名称
  const type = '项目'
  const title = rName + title_part

  let data = { type, action, title, content, rid, pid, rName, pName }
  checkFields(data, ['type', 'action', 'title', 'content', 'rid', 'pid'])
  data = { notify: data, to: toAccounts }
  const ans = await app.service('notify').addNotify(data)

  console.log(ans.status)
  console.log(`${JSON.stringify(data.notify)}\n${JSON.stringify(data.to)}`)
}

function getAllReceiver(project) {
  let toAccounts = []
  ;(project.客户开发 || []).forEach(key => toAccounts.push(key))
  ;(project.项目对接 || []).forEach(key => toAccounts.push(key))
  ;(project.项目经理 || []).forEach(key => toAccounts.push(key))
  const guwen_account = app.user.account
  toAccounts.push(guwen_account)
  // 去重
  toAccounts = Array.from(new Set(toAccounts))
  return toAccounts
}

function checkFields(data, keys) {
  for (const key of keys) {
    if (!data[key]) {
      throw new Error(key, 'is null!')
    }
  }
}

function getContent(form, keys_string) {
  // "候选人、推荐顾问、职位、专业职级、固定年薪、offer签订日期、预计到岗时间、到岗日期、备注"
  const keys = keys_string.split('、')
  const content = {}

  keys.forEach(key => {
    content[key] = form[key]
  })
  return content
}

export default {
  sendMessage: sendMessage,
  getContent,
  sendMessage3,
}
